import React, { Fragment } from "react";
import { NumberInput } from "react-admin";

const VolleyballTeamStats = ({ className, side }) => {
  const s = (key) => `${side}.girlsvolleyball.${key}`;
  return (
    <Fragment>
      <NumberInput
        label="Final Score"
        source={s("finalScore")}
        className={className}
      />
      <NumberInput
        label="Game 1 Points"
        source={s("game1Points")}
        className={className}
      />
      <NumberInput
        label="Game 2 Points"
        source={s("game2Points")}
        className={className}
      />
      <NumberInput
        label="Game 3 Points"
        source={s("game3Points")}
        className={className}
      />
      <NumberInput
        label="Game 4 Points"
        source={s("game4Points")}
        className={className}
      />
      <NumberInput
        label="Game 5 Points"
        source={s("game5Points")}
        className={className}
      />
      <NumberInput label="Kills" source={s("kills")} className={className} />
      <NumberInput label="Aces" source={s("aces")} className={className} />
      <NumberInput label="Digs" source={s("digs")} className={className} />
      <NumberInput
        label="Assists"
        source={s("assists")}
        className={className}
      />
    </Fragment>
  );
};

export default VolleyballTeamStats;
